
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class DeploymentBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class DeploymentBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u: string = data._id.match(/^cc-(.*)/i)[1];

    const pass: string   = data.dt.p ? 'PASS' : 'FAIL';
    const  dir: string   = data.dt.r ? 'REV' : 'FWD';

    let  route: any      = null;

    if (data.rt != null) {

      route = {
        id:              data.rt.i,
        seq:             parseInt(data.seq),
        status:          data.rt.f,
        statusOtherWay:  data.rt.b,
        mask:            data.rt.m
      };
    }

    let before = null;
    let after  = null;

    if ((data.tr.b != null) && (typeof data.tr.b.d != 'undefined')) {

      before = {
        name:    data.tr.b.d,
        mileage: data.tr.b.m
      }
    }

    if ((data.tr.a != null) && (typeof data.tr.a.d != 'undefined')) {

      after = {
        name:    data.tr.a.d,
        mileage: data.tr.a.m
      }
    }

    const track: any     = {
      desc:    data.tr.t,
      id:      data.tr.i,
      mileage: data.tr.m,
      before,
      after
    };

    let title: string    = '';

    if (route != null) {

      title += `RT: ${route.id} `;
    }

    title += `${track.desc} TRK: (${track.id})`;


    let name: string = `${dir} | ${pass} - ${title}`;
    let depart:  any = null;

    /*
     * decision point groups, dispatches and deployments can all be a branch in the tree that
     * was actually used for move a train.  Many of these branches are not...because the attempt
     * is made to move the train, but it can't for any number of reasons.  THe branches that do
     * get used...should normally be the most recent branch in the parent; since we move trains
     * as soon as they can move.
     *
     * Regardless, we let the simulator tell us what the "actual" move branches are; the parent
     * will have its 'depart' field filled in with a pointer to the depart event that ties together
     * all levels of the branch of the context tree that was used in an actual train move.  So,
     * if that depart field is filled in...then we check to see if our level is in the "actual"
     * branch.
     *
     */

    if ((typeof args.parent.depart != 'undefined') && (args.parent.depart != null)) {

      if (data._id == args.parent.depart.tc) {

        /* yup, this is an actual move branch */

        name = `${dir} | ${pass} - ${title}`;

      }

      depart = args.parent.depart;
    }

    return {
      id:          data._id,
      seq:         parseInt(data.seq),
      name,
      hasChildren: args.hasChildren, isExpanded: args.isExpanded,
      type:        'deployment',
      children:    args.children,
      parent:      args.parent,
      depart,
      tags:        data.tg,
      label:       data.lb,
      pkey:        data.pa,
      track,
      route,
      u
    };

  }
}
